<script setup>
import { defineProps, computed} from "vue";
import TabelaDeNotasFiscaisEmitidas from "./TabelaDeNotasFiscaisEmitidas/TabelaDeNotasFiscaisEmitidas.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "parcela",
    "adiantamento"
]);

//==================================================================//
//========================== Mostra Tabela =========================//
//==================================================================//

let mostraTabela = computed(()=>{

    if(props?.adiantamento?.notasFiscaisEmitidas?.length <= 0){
        return false;
    }

    if(props?.adiantamento?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
        v-show="mostraTabela"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <TabelaDeNotasFiscaisEmitidas
                    :dado="props?.dado"
                    :parcela="props?.parcela"
                    :adiantamento="props?.adiantamento"
                ></TabelaDeNotasFiscaisEmitidas>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__row:hover{
    background-color: #eeeeee;
}

.c-table__cell{
    grid-column: 3 / -1;
}

</style>
